import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { addShiftApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const addShift = createAsyncThunk('addShift', async (payload) => {
  return await addShiftApi(payload);
});

const addShiftSlice = createSlice({
  name: 'addShift', // Unique Name
  initialState,
  reducers: {
    addShiftReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(addShift.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(addShift.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(addShift.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { addShiftReset } = addShiftSlice.actions;

export default addShiftSlice.reducer;
